import { useDisclosure } from '@chakra-ui/react'
import { useState } from 'react'

import { ICreateShareLinkResponse } from '@/types/highlight.interface'
import { toastError } from '@/utils/toastError'

interface IUseHighlightShareDialog {
	selectedFolderIds: number[]
	createShareLink: (folderIds: number[]) => Promise<ICreateShareLinkResponse>
}

export const useHighlightShareDialog = ({
	selectedFolderIds,
	createShareLink
}: IUseHighlightShareDialog) => {
	const [shareUrl, setShareUrl] = useState('')
	const shareLinkModal = useDisclosure()

	const createAndShowShareLink = async (folderIds: number[]) => {
		if (!folderIds.length) return

		try {
			const response = await createShareLink(folderIds)

			const url = `${window.location.origin}/live/shared/${response.token}`

			setShareUrl(url)
			shareLinkModal.onOpen()
		} catch (error) {
			console.log(error)
		}
	}

	const shareSelectedFolders = async () => {
		await createAndShowShareLink(selectedFolderIds)
	}

	const shareFolder = async (folderId: number) => {
		await createAndShowShareLink([folderId])
	}

	const copyShareLink = async () => {
		try {
			await navigator.clipboard.writeText(shareUrl)
			shareLinkModal.onClose()
		} catch (error) {
			console.log(error)
			toastError('Failed to copy link. Please try again.')
		}
	}

	return {
		shareUrl,
		shareLinkModal,
		shareSelectedFolders,
		shareFolder,
		copyShareLink
	}
}
